import { Controller } from "@hotwired/stimulus";

// Switches between tab panels, showing one at a time.
// Supports ?tab= URL parameter to activate a tab by name on connect.
export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = { names: Array };

  connect() {
    const tabName = new URLSearchParams(window.location.search).get("tab");

    if (tabName && this.hasNamesValue) {
      const index = this.namesValue.indexOf(tabName);
      if (index >= 0) {
        this._activate(index);
      }
    }
  }

  switch(event) {
    const index = this.tabTargets.indexOf(event.currentTarget);
    this._activate(index);
  }

  _activate(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("tab-active", i === index);
    });

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index);
    });
  }
}
